import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/lib/services/common-service'
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client';
import { ConvertMainteInfo, MaintenanceUpdateRequest } from 'src/lib/entity/live';

@Component({
  selector: 'maintenance-create',
  templateUrl: './maintenance-create.component.html',
  styleUrls: [ '../../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss', './maintenance-create.component.scss']
})
export class MaintenanceCreateComponent implements OnInit {

  mainteStartedAt: string | undefined;
  mainteEndedAt: string | undefined;
  mainteCheckboxAll: boolean = true;
  mainteCheckboxWeb: boolean = true;
  mainteCheckboxIos: boolean = true;
  mainteCheckboxAndroid: boolean = true;
  mainteErrorTxt: string = undefined;

  maintenanceInfo: ConvertMainteInfo;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.commonService.maintenanceInfo.subscribe(data => {
      this.maintenanceInfo = data;
    });
  }

  public mainteUpdate() {
    // バリデーションチェック
    this.mainteErrorTxt = this.checkMainteDateValidation();

    if (this.mainteErrorTxt === 'success') {

      let inputPlatform = [];
      if (this.mainteCheckboxWeb) inputPlatform.push('maglive-web-front');
      if (this.mainteCheckboxIos) inputPlatform.push('maglive-iOS');
      if (this.mainteCheckboxAndroid) inputPlatform.push('maglive-android');

      // long型に合うよう変換している
      let startedAt = Date.parse(this.mainteStartedAt).toString().slice(0,-3)
      let endedAt = Date.parse(this.mainteEndedAt).toString().slice(0,-3)

      let params: MaintenanceUpdateRequest = {
        startedAt: Number(startedAt),
        endedAt: Number(endedAt),
        platform: inputPlatform
      }
      MagliveApiClient.updateMaintenanceInfo(params).subscribe();

      this.router.navigate(['/admin/maintenance'], { relativeTo: this.route });
    }
  }

  public checkboxControllAll() {
    // 全プラットフォームがチェックされたら他は全てfalseにする
    if (!this.mainteCheckboxAll) {
      this.mainteCheckboxWeb = true
      this.mainteCheckboxIos = true
      this.mainteCheckboxAndroid = true
    } else {
      this.mainteCheckboxWeb = false
      this.mainteCheckboxIos = false
      this.mainteCheckboxAndroid = false
    }
  }

  // チェックが押された直後は変数の中身が切り替わっていないため、html側では逆のboolを渡している
  public checkboxControl(checkboxInfo: object|any) {
    // allにチェックが入った状態でweb/ios/androidにチェックが入ったらallのチェックを外す

    // 全プラットフォームにチェックが入った時の挙動
    if (checkboxInfo.button === 'all' && checkboxInfo.isCheck === true) {
      this.mainteCheckboxWeb = true
      this.mainteCheckboxIos = true
      this.mainteCheckboxAndroid = true
    } else if (checkboxInfo.button === 'all' && checkboxInfo.isCheck === false) {
      this.mainteCheckboxWeb = false
      this.mainteCheckboxIos = false
      this.mainteCheckboxAndroid = false
    }

    // PC/その他
    if (checkboxInfo.button === 'web' && checkboxInfo.isCheck && this.mainteCheckboxIos && this.mainteCheckboxAndroid) {
      this.mainteCheckboxAll = true
    } else if (checkboxInfo.button === 'web' && checkboxInfo.isCheck === false) {
      this.mainteCheckboxAll = false
    }

    // ios
    if (checkboxInfo.button === 'ios' && checkboxInfo.isCheck && this.mainteCheckboxWeb && this.mainteCheckboxAndroid) {
      this.mainteCheckboxAll = true
    } else if (checkboxInfo.button === 'ios' && checkboxInfo.isCheck === false) {
      this.mainteCheckboxAll = false
    }

    // android
    if (checkboxInfo.button === 'android' && checkboxInfo.isCheck && this.mainteCheckboxWeb && this.mainteCheckboxIos) {
      this.mainteCheckboxAll = true
    } else if (checkboxInfo.button === 'android' && checkboxInfo.isCheck === false) {
      this.mainteCheckboxAll = false
    }
  }

  private checkMainteDateValidation() {
    let result = "success";
    if (this.mainteStartedAt === undefined || this.mainteEndedAt === undefined) {
      result = "日付が選択されていません。"
    } else {
      let today = new Date(Date.now());
      let startedAt = new Date(this.mainteStartedAt)
      let endedAt = new Date(this.mainteEndedAt)
      if (today.getTime() > endedAt.getTime()) {
        result = "終了日時は現在日時より後に設定してください。"
      } else if (startedAt.getTime() > endedAt.getTime()) {
        result = "終了日時は開始日時より後に設定してください。"
      }
    }
    return result;
  }

  //  メンテナンス設定画面のキャンセルボタン
  public mainteCancel() {
    this.mainteStartedAt =  undefined;
    this.mainteEndedAt = undefined;
    this.mainteCheckboxAll = true;
    this.mainteCheckboxWeb = true;
    this.mainteCheckboxIos = true;
    this.mainteCheckboxAndroid = true;
    this.mainteErrorTxt = undefined;
    this.router.navigate(['/admin/maintenance'], { relativeTo: this.route });
  }

}
